export default __webpack_public_path__ + "static/media/hilden_dark.b3adf03f.png";